<!-- 工艺备注 -->
<template>
  <BaseFormItem
    class="postscript"
    :label="fields.label"
  >
    <div class="postscript__content">
      <BaseInput
        v-model="val.postscript"
        type="textarea"
        width="100%"
        resize="none"
        :placeholder="isDevelopOrderDisabled ? '研发型暂不支持工艺备注，如需填写请切换为标准型订单' : '如有在极性方向、元器件要求、回流温度等方面的要求，请在此填写'"
        maxlength="300"
        show-word-limit
        :row="3"
        :disabled="isDevelopOrderDisabled"
        @input="() => handleEmit('postscript')"
      />
      <div class="postscript__content__upload">
        <UploadAnnex 
          :fileUrl="val.file_postscript"
          :accept="accept"
          :fileName="val.file_postscript_name"
          :disabled="isDevelopOrderDisabled"
          @change="handleUploadChange"
        />
      </div>
    </div>
  </BaseFormItem>
</template>

<script>
// 上传附件
import UploadAnnex from '../components/uploadAnnex'
import {  isMyCenterSite } from '@@/utils/is'
import { getSMTFields } from '@@/utils/getFields'

export default {
  props: {
    // 工艺备注
    postscript: {
      type: String,
      default: ''
    },
    // 工艺备注附件地址
    file_postscript: {
      type: String,
      default: ''
    },
    // 工艺备注附件名称
    file_postscript_name: {
      type: String,
      default: ''
    },
    // 订单类型：0-标准型 1-研发型
    is_develop_order: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    UploadAnnex
  },
  data() {
    return {
      val: {
        postscript: this.postscript,
        file_postscript: this.file_postscript,
        file_postscript_name: this.file_postscript_name
      }
    }
  },
  computed: {
    fields() {
      return getSMTFields('postscript')
    },
    accept() {
      return isMyCenterSite ? '*' : void 0
    },
    // 研发型订单时禁用输入和上传
    isDevelopOrderDisabled() {
      return Number(this.is_develop_order) === 1
    }
  },
  watch: {
    postscript(newVal) {
      this.val.postscript = newVal
    },
    file_postscript(newVal) {
      this.val.file_postscript = newVal
    },
    file_postscript_name(newVal) {
      this.val.file_postscript_name = newVal
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
    },
    handleUploadChange(data) {
      const { fileUrl, fileName } = data || {}
      this.val.file_postscript = fileUrl || ''
      this.val.file_postscript_name = fileName || ''
      this.handleEmit('file_postscript')
      this.handleEmit('file_postscript_name')
    }
  }
}
</script>

<style lang="scss" scoped>
.postscript__content {
  box-sizing: border-box;
  padding: 10px;
  width: 560px;
  border-radius: 4px;
  background-color: $--background-hover;
  .postscript__content__upload {
    margin-top: 6px;
    ::v-deep {
      .base-button.el-button {
        padding: 0 10px;
        height: 24px;
        line-height: 22px;
      }
    }
  }
}
</style>